export function defaultAmountRequested(homeValue: number, sliderStep: number): number {
  return (
    Math.ceil(Math.min(Math.max(Math.round(homeValue * 0.2), 5000000), 150000000) / sliderStep) * sliderStep
  );
}

export function amountRequestedMaximum(homeValue: number, maximumLTV: number): number {
  return Math.min(150000000, homeValue ? Math.floor(homeValue * maximumLTV) : 150000000);
}
